module.exports = __webpack_public_path__ + "img/CenturySunshine-icon.9e5f1cfa.png";